<script setup>
defineProps({
  quickReplies: { type: Array, default: () => [] },
});
</script>

<template>
  <div v-if="quickReplies.length" class="flex flex-wrap gap-1.5 mt-2">
    <span
      v-for="(quickReply, index) in quickReplies"
      :key="index"
      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs bg-n-alpha-1 text-n-slate-11 border border-n-weak"
    >
      {{ quickReply.title }}
    </span>
  </div>
</template>
